<template>
  <ul>
    <template v-for="(item, index) in datas">
      <li class="title" :key="item.questionId + item.questionId">
        {{ `${index + 1}. ${item.questionTitle}` }}
      </li>
      <ul class="selection" :key="item.questionId">
        <el-radio-group
          v-if="!multiple"
          :value="item.userAnswer || ''"
          :disabled="type != 'add'"
        >
          <li
            class="option"
            v-for="option in item.optionList"
            :key="option.optionId"
          >
            <el-radio
              el-radio
              :label="option.optionNo"
              @change="
                val => {
                  answerChanged(val, item, option.optionNo);
                }
              "
              >{{ option.optionNo + "." + option.optionTitle }}</el-radio
            >
          </li>
        </el-radio-group>
        <el-checkbox-group
          v-else
          :value="item.userAnswer || ''"
          :disabled="type != 'add'"
        >
          <li
            class="option"
            v-for="option in item.optionList"
            :key="option.optionId"
          >
            <el-checkbox
              :label="option.optionNo"
              @change="
                val => {
                  mutipleAnswerChanged(val, item, option.optionNo);
                }
              "
              >{{ option.optionNo + "." + option.optionTitle }}</el-checkbox
            >
          </li>
        </el-checkbox-group>
        <div style="padding: 5px 0;" v-if="type === 'result'">
          <span class="answer">{{ `正确答案： ${item.correctAnswer}` }}</span>
          <span class="answer result"
            >答题对错：<span :class="{ wrong: !item.isCorrect }">{{
              `${item.isCorrect ? "对" : "错"}`
            }}</span>
          </span>
        </div>
      </ul>
    </template>
  </ul>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: function() {
        return [];
      }
    },
    type: {
      type: String,
      default: "preview" //preview => 试卷预览   result => 考试结果预览  add => 添加成绩
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    answerChanged(val, item, optionNo) {
      item.userAnswer = optionNo;
      // 只有当用户从正确答案选到错误答案或者从错误答案选到正确答案时才派发处理事件
      if (
        (val != item.correctAnswer && optionNo === item.correctAnswer) ||
        (val === item.correctAnswer && optionNo != item.correctAnswer)
      ) {
        this.$emit("answerChanged", item.userAnswer === item.correctAnswer);
      }
    },
    mutipleAnswerChanged(val, item, optionNo) {
      let flag =
        item.userAnswer.sort().toString() === item.correctAnswer.toString();
      if (val) {
        item.userAnswer.push(optionNo);
      } else {
        item.userAnswer.splice(item.userAnswer.indexOf(optionNo), 1);
      }
      item.userAnswer.sort();
      item.correctAnswer.sort();
      if (
        (!flag &&
          item.userAnswer.toString() === item.correctAnswer.toString()) ||
        (flag && item.userAnswer.toString() != item.correctAnswer.toString())
      ) {
        this.$emit(
          "answerChanged",
          item.userAnswer.toString() === item.correctAnswer.toString()
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #343c4a;
@mixin text {
  color: $color;
  font-size: 14px;
}
ul {
  padding: 0 15px;
}
li {
  @include text;
}
.title {
  margin: 5px 0;
  padding: 0 5px;
  list-style: none;
}
.selection {
  padding-left: 15px;
  margin-bottom: 10px;
  .option {
    list-style: none;
    padding: 5px 5px;
    display: inline-block;
    margin-right: 10px;
    /deep/ .el-radio__label {
      display: inline-block;
      vertical-align: middle;
      @include text;
      font-weight: normal;
    }
    /deep/ .el-checkbox__label {
      @include text;
      font-weight: normal;
    }
    /deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner {
      background-color: #3a85ff;
    }
    /deep/ .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
      background-color: #3a85ff;
    }
  }
  .answer {
    @include text;
  }
  .result {
    margin-left: 40px;
    .wrong {
      color: #3a85ff;
    }
  }
}
</style>
